import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
} from "chart.js";

// Register ChartJS components
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend
);

const ProfitGraph = ({ timeframe, setTimeframe, dataType, setDataType }) => {
    // Chart data
    const chartData = {
        labels: ["Jun", "Jul", "Aug", "Sep", "Oct", "Nov"],
        datasets: [
            {
                fill: true,
                label: "Portfolio Value",
                data: [25000, 42000, 35000, 30000, 45000, 50300],
                borderColor: "#4ECCA3",
                backgroundColor: "rgba(78, 204, 163, 0.1)",
                tension: 0.4,
                pointBackgroundColor: "#4ECCA3",
                pointBorderColor: "#000",
                pointBorderWidth: 2,
                pointRadius: 4,
                pointHoverRadius: 6,
            },
        ],
    };

    // Chart options
    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                backgroundColor: "#1E1E1E",
                titleColor: "#fff",
                bodyColor: "#fff",
                borderColor: "#4ECCA3",
                borderWidth: 1,
                padding: 10,
                displayColors: false,
                callbacks: {
                    label: (context) => `$${context.raw.toLocaleString()}`,
                },
            },
        },
        scales: {
            x: {
                grid: {
                    display: false,
                    drawBorder: false,
                },
                ticks: {
                    color: "#6c757d",
                },
            },
            y: {
                grid: {
                    color: "rgba(255, 255, 255, 0.05)",
                    drawBorder: false,
                },
                ticks: {
                    color: "#6c757d",
                    callback: (value) => {
                        if (value >= 1000) {
                            return `$${value / 1000}k`;
                        }
                        return `$${value}`;
                    },
                },
            },
        },
    };

    return (
        <div className="card mb-4">
            <div className="card-body p-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className="text-white fs-5 m-0">Profit graph</h3>
                    <div className="d-flex">
                        <div
                            className="me-2 px-3 py-1 rounded-pill"
                            style={{
                                backgroundColor: "rgba(255, 255, 255, 0.1)",
                                cursor: "pointer",
                            }}
                            onClick={() => {
                                // Toggle between timeframes
                                setTimeframe(
                                    timeframe === "Monthly"
                                        ? "Weekly"
                                        : "Monthly"
                                );
                            }}
                        >
                            <span className="text-secondary small">
                                {timeframe} ▼
                            </span>
                        </div>
                        <div
                            className="px-3 py-1 rounded-pill"
                            style={{
                                backgroundColor: "rgba(255, 255, 255, 0.1)",
                                cursor: "pointer",
                            }}
                            onClick={() => {
                                // Toggle between data types
                                setDataType(
                                    dataType === "Earnings"
                                        ? "Growth"
                                        : "Earnings"
                                );
                            }}
                        >
                            <span className="text-secondary small">
                                {dataType} ▼
                            </span>
                        </div>
                    </div>
                </div>

                {/* Current Value */}
                <div className="position-relative mb-2">
                    <div
                        className="position-absolute start-50 top-50 translate-middle text-center"
                        style={{
                            backgroundColor: "rgba(18, 18, 30, 0.8)",
                            padding: "8px 12px",
                            borderRadius: "8px",
                            zIndex: 10,
                        }}
                    >
                        <h4 className="text-white fs-4 fw-bold mb-0">$50,3k</h4>
                        <span className="text-success small">↑ 3.2%</span>
                    </div>

                    {/* Chart */}
                    <div style={{ height: "200px" }}>
                        <Line data={chartData} options={chartOptions} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfitGraph;
